var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 20,
    viewBox: "0 0 6 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15343 2.70355C5.15343 3.92053 4.16687 4.9071 2.94989 4.9071C1.7329 4.9071 0.746338 3.92053 0.746338 2.70355C0.746338 1.48656 1.7329 0.5 2.94989 0.5C4.16687 0.5 5.15343 1.48656 5.15343 2.70355ZM5.15343 9.99984C5.15343 11.2168 4.16687 12.2034 2.94989 12.2034C1.7329 12.2034 0.746338 11.2168 0.746338 9.99984C0.746338 8.78286 1.7329 7.79629 2.94989 7.79629C4.16687 7.79629 5.15343 8.78286 5.15343 9.99984ZM2.94989 19.5C4.16687 19.5 5.15343 18.5134 5.15343 17.2964C5.15343 16.0794 4.16687 15.0929 2.94989 15.0929C1.7329 15.0929 0.746338 16.0794 0.746338 17.2964C0.746338 18.5134 1.7329 19.5 2.94989 19.5Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIc);
export default __webpack_public_path__ + "static/media/menu_ic.50147d38637e107a14fa282a1bc4450f.svg";
export { ForwardRef as ReactComponent };